import { MintableReturn } from '@zoralabs/protocol-sdk';
import { useState } from 'react';
import { useCollectorClient } from './useCollectorClient';

export const useGetToken = () => {
  const [token, setToken] = useState<MintableReturn | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [called, setCalled] = useState<boolean>(false);
  const [error, setError] = useState<any>();
  const { data: collectorClient } = useCollectorClient();

  const fetchToken = async ({ contractAddress, tokenId }: { contractAddress: string; tokenId: string }) => {
    if (loading) {
      return;
    }

    setCalled(true);
    setLoading(true);

    try {
      const newToken = await collectorClient?.getToken({
        // contract address tokens belongs to
        tokenContract: contractAddress as `0x${string}`,
        tokenId: BigInt(tokenId),
        mintType: '1155',
      });

      if (!newToken) {
        return;
      }

      setToken(newToken);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  return {
    token,
    loading,
    called,
    error,
    execute: fetchToken,
  };
};
